// Alpha Tex logo — uses the official cropped mark (transparent background).
// Wordmark "ALPHA TEX" is rendered in solid black next to it.
import React from 'react';

const MARK_SRC = '/brand/alpha-tex-mark-silver.png';

export function AlphaTexMark({ className = '', title = 'Alpha Tex' }) {
  return (
    <img
      src={MARK_SRC}
      alt={title}
      className={`object-contain select-none ${className}`}
      draggable="false"
    />
  );
}

export function AlphaTexLockup({ className = '', compact = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <AlphaTexMark className={compact ? 'w-10 h-11 shrink-0' : 'w-11 h-12 shrink-0'} />
      <div className="leading-[0.95]">
        <div
          className={`font-display uppercase tracking-tight text-[#0A0A0A] ${
            compact ? 'text-lg' : 'text-xl md:text-[22px]'
          }`}
        >
          ALPHA TEX
        </div>
        <div className="font-mono-label text-[9px] tracking-[0.28em] uppercase text-[#0A0A0A]/55 mt-1 flex items-center gap-1.5">
          <span>Construction · Remodel</span>
          <span className="w-1 h-1 rounded-full bg-[#DC2626]" />
          <span className="text-[#1D4ED8]">Est. 2023</span>
        </div>
      </div>
    </div>
  );
}

export default AlphaTexLockup;
